import React from 'react';

import BlogPostList from '../../../components/Admin/BlogPosts/BlogPostList.module';

function BlogPostListView() {
  return (
    <BlogPostList />
  );
}

export default BlogPostListView; 